// axios
import axios from 'axios'
import config from '../public/harness_config.json'

const baseURL = `${config.scheme}://${config.url}/${config.api_version}` //'https://staging.harnessapp.com/v2.0';

export default axios.create({
  baseURL,
  // You can add your headers here
})
